// extracted by mini-css-extract-plugin
module.exports = {"Property":"Property_Property__YgEP4"};